export default __webpack_public_path__ + "static/media/group1.4234a637.jpg";